import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 40 }}>
    <h2 style={{ fontSize: 20, fontWeight: 600, color: '#00d55b', marginBottom: 14, paddingBottom: 10, borderBottom: '1px solid #1e1e1e' }}>{title}</h2>
    <div style={{ color: '#888', fontSize: 14, lineHeight: 1.9 }}>{children}</div>
  </div>
);

export default function PrivacyPage() {
  return (
    <div style={{ background: '#000', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '64px 24px' }}>
        <div style={{ marginBottom: 48 }}>
          <h1 style={{ fontSize: 38, fontWeight: 700, marginBottom: 12 }}>Privacy <span style={{ color: '#00d55b' }}>Policy</span></h1>
          <p style={{ color: '#555', fontSize: 14 }}>Last updated: January 2025 · MS Discoveries</p>
        </div>
        <div style={{ background: '#0d0d0d', border: '1px solid rgba(0,213,91,0.2)', borderRadius: 12, padding: '16px 20px', marginBottom: 40 }}>
          <p style={{ color: '#888', fontSize: 13, lineHeight: 1.8 }}>MS Discoveries is committed to protecting your privacy. This policy explains what data we collect, how we use it, and your rights regarding your data when using the MSChat platform.</p>
        </div>
        <Section title="1. Information We Collect">
          <p><strong style={{ color: '#fff' }}>From Businesses (Clients):</strong></p>
          <ul style={{ marginTop: 8, paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <li>Company name, owner name, email address, phone number</li>
            <li>Payment transaction IDs and screenshots (for verification only)</li>
            <li>Branding assets including logos and color preferences</li>
            <li>Account usage data including login times and settings changes</li>
          </ul>
          <p style={{ marginTop: 14 }}><strong style={{ color: '#fff' }}>From Visitors (via chat widget):</strong></p>
          <ul style={{ marginTop: 8, paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <li>Name, email address, and phone number (from pre-chat form)</li>
            <li>Chat messages and conversation history</li>
            <li>IP address (partially masked for privacy)</li>
            <li>Country, city (detected from IP address)</li>
            <li>Device type, browser, and operating system</li>
            <li>Current page URL and traffic source (referrer)</li>
            <li>Time spent on website before chatting</li>
          </ul>
        </Section>
        <Section title="2. How We Use Your Information">
          <ul style={{ paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <li>To provide and maintain the MSChat service</li>
            <li>To verify payments and activate accounts</li>
            <li>To send account-related notifications (activation, renewal reminders, suspension warnings)</li>
            <li>To provide analytics and reporting to business clients</li>
            <li>To improve our platform and develop new features</li>
            <li>To respond to support requests and enquiries</li>
            <li>To comply with legal obligations</li>
          </ul>
        </Section>
        <Section title="3. Data Storage & Retention">
          <p><strong style={{ color: '#fff' }}>Pack One clients:</strong> Chat history is stored for 7 days and then automatically deleted.</p>
          <p style={{ marginTop: 10 }}><strong style={{ color: '#fff' }}>Pack Two & Advanced clients:</strong> Chat history is stored permanently as long as the account is active.</p>
          <p style={{ marginTop: 10 }}><strong style={{ color: '#fff' }}>Account deletion:</strong> When an account is permanently deleted (Day 8 after suspension), all data including chat history, visitor information, agent accounts, and branding is irreversibly deleted from our servers.</p>
          <p style={{ marginTop: 10 }}>All data is stored on secure servers. We use industry-standard encryption for data transmission.</p>
        </Section>
        <Section title="4. Data Sharing">
          <p>We do not sell, rent, or share your personal data or visitor data with third parties for marketing purposes.</p>
          <p style={{ marginTop: 10 }}>We may share data in the following limited circumstances:</p>
          <ul style={{ marginTop: 8, paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <li>With service providers who assist in operating our platform (under strict confidentiality agreements)</li>
            <li>When required by law, court order, or government authority</li>
            <li>To protect the rights, property, or safety of MS Discoveries, our clients, or the public</li>
          </ul>
        </Section>
        <Section title="5. Cookies">
          <p>MSChat uses essential cookies to maintain session state and authentication. We do not use tracking cookies or third-party advertising cookies.</p>
          <p style={{ marginTop: 10 }}>The chat widget embedded on client websites may use a browser storage mechanism to identify returning visitors and maintain chat session continuity.</p>
        </Section>
        <Section title="6. Data Security">
          <p>We implement appropriate technical and organizational security measures to protect your data, including SSL/TLS encryption, secure password hashing, and access controls. However, no method of internet transmission is 100% secure.</p>
        </Section>
        <Section title="7. Your Rights">
          <p>As a client or visitor, you have the right to:</p>
          <ul style={{ marginTop: 8, paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data (subject to legal obligations)</li>
            <li>Object to processing of your data in certain circumstances</li>
          </ul>
          <p style={{ marginTop: 10 }}>To exercise these rights, contact us at halo@msdiscoveries.com.</p>
        </Section>
        <Section title="8. Children's Privacy">
          <p>MSChat is not intended for use by children under the age of 13. We do not knowingly collect personal information from children. If you believe a child has provided us with personal information, please contact us immediately.</p>
        </Section>
        <Section title="9. Changes to This Policy">
          <p>We may update this Privacy Policy from time to time. We will notify registered clients of any material changes via email. Continued use of the service after changes constitutes acceptance of the updated policy.</p>
        </Section>
        <Section title="10. Contact Us">
          <p>For any privacy-related questions or to exercise your data rights, contact us:</p>
          <div style={{ marginTop: 12, background: '#111', border: '1px solid #1e1e1e', borderRadius: 10, padding: '16px 20px', display: 'inline-block' }}>
            <div style={{ marginBottom: 6 }}>🏢 <strong style={{ color: '#fff' }}>MS Discoveries</strong></div>
            <div style={{ marginBottom: 6 }}>📧 <a href="mailto:halo@msdiscoveries.com" style={{ color: '#00d55b' }}>halo@msdiscoveries.com</a></div>
            <div>📞 <a href="tel:+919443724724" style={{ color: '#00d55b' }}>+91 9443724724</a></div>
          </div>
        </Section>
      </div>
      <Footer />
    </div>
  );
}
